import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import "react-responsive-carousel/lib/styles/carousel.min.css" // requires a loader
import { Carousel } from "react-responsive-carousel"
import styled from "styled-components"

const services = [
  {
    name: "Bio-Identical Hormone Replacement",
    slug: "bio-identical-hormone-replacement",
    img: "bihr.png",
    tagline:
      "Our clinic strives to Restore and Maintain Health through Innovative Functional Medicine.",
    intro:
      "Today’s world is filled with thousands of harmful As we age the body’s major hormone systems decline in function. Stamina, vitality, muscle strength and sexual function can all be improved with the restoration of our youthful hormone levels.Copying the way nature functions and replenishing these hormones with Bio-Identical hormones will generally give the best results.",
    description:
      "Women who replace the sex hormones of their youth will notice improved energy, with decreased risks of dementia, osteoporosis and other diseases associated with aging, not to mention relieving most of the symptoms of peri-menopause and menopause. Hormone replacement isn’t just for women. Men over the age of 40 will begin to notice that they gain weight easily and that they experience a reduction in their strength, libido and vitality as a result of their decreasing testosterone level. It is crucial for men to realize that as they age their decreasing testosterone can convert to the female hormone, estrogen, which can affect their risk of developing prostate problems, diabetes and additional conditions.",
    ending:
      "Having a customized treatment plan designed to optimize these hormones will improve vitality and decrease their risk of age incurred debilitating diseases.",
  },
  {
    name: "Detoxification",
    slug: "detoxification",
    img: "detox.png",
    tagline:
      "Our clinic strives to Restore and Maintain Health through Innovative Functional Medicine.",
    intro:
      "Today’s world is filled with thousands of harmful and toxic agents. At no other time in history has mankind been exposed to so many chemicals and toxins. For the first time in history the younger generation may not outlive their parents. The air we breathe, the water we drink, and the foods we eat potentially contain toxins that that can erode our health. Cancer occurrences are at an all-time high and will most likely continue to increase over the next several decades.",
    description:
      "We are finding that most people suffering with a chronic illness will usually have an underlying toxicity problem. It is important to determine the types of toxicities present, so that ongoing exposure can be curtailed and detoxification begun. There are several ways of assessing these toxicities and their damage to the body and one’s health. Thanks to various lab tests which are now available we are able to assess one’s toxic load. Individual toxins such as heavy metals, phthalates, plastics, Styrofoam, as well as many others can be identified. Once the toxins are identified an individualized detoxification program can be implemented.",
    ending:
      "We offer several modalities of detoxifying the body. By using a variety of techniques such as intravenous chelation, PK protocol, homeopathic detox programs, gut restoration programs, liver support and gallbladder flushes these toxins can be removed and health restored. A vital part of our detox programs is lifestyle education, where patients are guided in how to make healthier life style choices.",
  },
  // {
  //   name: "Insulin Potentiation Therapy",
  //   slug: "insulin-potentiation-therapy",
  //   img: "ipt.png",
  //   tagline:
  //     "Our clinic strives to Restore and Maintain Health through Innovative Functional Medicine.",
  //   intro:
  //     "Insulin Potentiation Therapy is a simple medical procedure that uses the hormone insulin, followed by chemotherapy and glucose, to make chemotherapy drugs more effective, in smaller doses, with few to no side effects. There are no double-blind, placebo-controlled, university-based, FDA, or pharmaceutical company-funded studies for IPT, or many of the other treatments that we do at our clinic. IPT was basically developed as a result of several doctors who better understood cancer physiology and how the body works, and who felt they could treat cancer patients with less toxic methods than whats found in conventional medicine.",
  //   description:
  //     "We are finding that most people suffering with a chronic illness will usually have an underlying toxicity problem. A Mexican doctor named Donato Perez Garcia, MD, was the first to notice that insulin, when combined with certain medications and nutrients, was useful for treating various health conditions. For instance, he and his son, also a doctor, found that insulin, when combined with low dosages of chemotherapy, was very effective for treating cancer patients. Their results were impressive and they presented their data to the National Health Institute (NIH) in the early 1960s. The NIH promptly shelved the information and has since made it difficult for physicians to get funding to study the effects of IPT. Since then, a growing international organization has been developed, which teaches IPT to interested physicians. In order to understand how IPT works, its important to first explain cancer cell physiology and compare it to that of normal cells. Cancer cells have six times as many receptors for insulin on the surface of their membranes as normal cells, and ten times as many IGF-1 factors, or Insulin Growth Factor-1 receptors. Insulin stimulates growth and the uptake of glucose into the cells for energy. It also transports amino acids and vitamins into the cell. Cancer has a high metabolism, and must feed itself. It prefers sugar and simple carbohydrates since it doesnít metabolize fats and proteins very well.",
  //   ending:
  //     "One reason we know that cancer cells have a higher than normal metabolism is because of PET scans, which reveal areas of increased metabolic activity in the body. These scans essentially involve injecting labeled sugar molecules into the body, which are then detected by scanners once they are inside the body. The sugar molecules go to areas of increased metabolic activity, which happen to be where the cancer is. To further understand how this works, consider the following example. Letís say you have a cage with a bunch of hamsters that are sleeping or crawling around, with the exception of one, which is very active, running on a wheel and burning a lot of calories. The active hamster represents a metabolically active tumor in a body of normal cells (which are the sleeping and crawling hamsters). Thus, tumor cells are more sensitive to sugar because they need more glucose for producing energy. So they pick up sugar by means of insulin, a lot faster and more aggressively than normal cells do. When doctors drop their patients blood sugar levels by giving them insulin, it creates a state in the body, called a therapeutic moment, in which the body elicits the release of adrenaline (epinephrine). This causes patients to feel hot, sweaty, and drowsy. When adrenaline and insulin are mixed together in a low blood sugar state, cancer cells and other inflamed cells become much more receptive to whatever substances are introduced to them through an IV, including chemotherapy. This means that doctors can give much lower doses of chemotherapy to their patients’, and their effects will be greatly enhanced, or potentiated, by the insulin. Only one-tenth of the full chemotherapy dose is needed to obtain effective results, and it can be administered in a much shorter period of time than regular chemotherapy. In order for IPT to be effective, the patients blood sugar levels must be dropped to 30-40 mg/dL (the normal range is 65-99 mg/dL). Despite this, the procedure is thoroughly safe. People do get a bit groggy, but after a while they get used to it, and after the procedure doctors can quickly restore their low blood sugar back to normal by giving them an infusion of glucose. To Read an additional detailed article on IPT located at Insulin Potentiation Therapy (IPT) and written by Webster Kehr, Independent Cancer Research Foundation, Inc. CLICK HERE",
  // },
  {
    name: "Oxidative Therapies",
    slug: "oxidative-therapies",
    img: "oxidative-therapies.png",
    tagline:
      "Our clinic strives to Restore and Maintain Health through Innovative Functional Medicine.",
    intro:
      "Along with chronic conditions most people harbor infections that tend to weaken their oxygen delivery abilities. Oxidative therapies can deliver much needed oxygen to the body and help to boost the immune system’s ability to kill off infections.",
    description:
      "People with chronic infection such as hepatitis, chronic fatigue and even acute infections such as those which can cause the flu or colds can benefit from such treatments.",
    ending: "",
  },
  {
    name: "Supportive Adjunctive Therapy",
    slug: "supportive-adjunctive-therapy",
    img: "supportive-adjuntive.png",
    tagline:
      "Our clinic strives to Restore and Maintain Health through Innovative Functional Medicine.",
    intro:
      "Each patient suffering from a chronic disease is treated individually and their treatments are based on their history, lab tests, and personal needs. Adjuncts are customized to each patient’s needs can be provided intravenously and/or orally. A comprehensive nutritional support program is developed for each patient to help restore the body’s processes to a state of optimum function.",
    description:
      "The nutritional support that is given is based on the type of illness the patient has and the treatments that he/she is receiving.",
    ending: "",
  },
  {
    name: "Thyroid",
    slug: "thyroid",
    img: "thyroid.png",
    tagline:
      "Our clinic strives to Restore and Maintain Health through Innovative Functional Medicine.",
    intro:
      "In this world of constant stress the thyroid gland that regulates metabolism and the adrenal glands that produce the life sustaining cortisol can be affected leading to feelings of being tired, increased sensitivity to cooler temperatures and feelings of depression. We offer lifestyle education to assist you in reducing the stress in your hectic lives, getting the proper amount rest, correcting our diets and supporting these organs with nutritional and herbal supplements in many cases can restore balance to the body without additional treatments.",
    description:
      "However when medications and additional treatments are indicated through the results of such testing as T4, free T3, free T4, and reverse T3, we offer full thyroid support in the most natural ways possible.",
    ending: "",
  },
  // {
  //   name: "Photodynamic Therapy",
  //   slug: "photodynamic-therapy",
  //   img: "photodynamic-therapy.png",
  //   tagline:
  //     "Quantum Functional Medicine is a center for health and rejuvenation.",
  //   intro: "we are using the Weber laser.",
  //   description:
  //     "However when medications and additional treatments are indicated through the results of such testing as T4, free T3, free T4, and reverse T3, we offer full thyroid support in the most natural ways possible.",
  //   ending: "",
  // },
  // {
  //   name: "Rejuvenation with Exosomes",
  //   slug: "rejuvenation-with-exosomes",
  //   img: "rejuvenation-with-exosomes.png",
  //   tagline:
  //     "Quantum Functional Medicine is a center for health and rejuvenation.",
  //   intro: "we are using Wharton’s jelly",
  //   description:
  //     "However when medications and additional treatments are indicated through the results of such testing as T4, free T3, free T4, and reverse T3, we offer full thyroid support in the most natural ways possible.",
  //   ending: "",
  // },
]

const CarouselWrap = styled.div`
  .legend {
    font-size: ${props => props.theme.fontSize.h5} !important;
    font-weight: bold;
  }

  @media (min-width: 1024px) {
    width: 50%;
  }
`

const ServicesCarousel = ({ service }) => {
  const data = useStaticQuery(graphql`
    query MoreServiceImageQuery {
      allFile(filter: { sourceInstanceName: { eq: "services-images" } }) {
        edges {
          node {
            relativePath
            childImageSharp {
              gatsbyImageData(
                width: 400
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
    }
  `)

  const imageData = data.allFile.edges.filter(
    img => img.node.relativePath !== service.img
  )

  const image1 = getImage(imageData[0].node)
  const image2 = getImage(imageData[1].node)
  const image3 = getImage(imageData[2].node)

  const otherService1 = services.filter(
    service => service.img === data.allFile.edges[0].node.relativePath
  )
  const otherService2 = services.filter(
    service => service.img === data.allFile.edges[1].node.relativePath
  )
  const otherService3 = services.filter(
    service => service.img === data.allFile.edges[2].node.relativePath
  )

  if (
    otherService1.lenth !== 0 &&
    otherService2.lenth !== 0 &&
    otherService3.lenth !== 0
  ) {
    return (
      <CarouselWrap>
        <Carousel showArrows showThumbs={false}>
          <div>
            <Link to={`/services/${otherService1[0].slug}`}>
              <GatsbyImage image={image1} alt={service.name} />

              <p className="legend">{otherService1[0].name}</p>
            </Link>
          </div>
          <div>
            <Link to={`/services/${otherService2[0].slug}`}>
              <GatsbyImage image={image2} alt={service.name} />
              <p className="legend">{otherService2[0].name}</p>
            </Link>
          </div>
          <div>
            <Link to={`/services/${otherService3[0].slug}`}>
              <GatsbyImage image={image3} alt={service.name} />
              <p className="legend">{otherService3[0].name}</p>
            </Link>
          </div>
        </Carousel>
      </CarouselWrap>
    )
  } else {
    return null
  }
}

export default ServicesCarousel
